import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const { t } = useTranslation('home');

  const featured = allArticles.filter((a) => a.featured).slice(0, 3);
  const latest = allArticles.slice(0, 6);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {t('article_title')}
            </h2>
            <p className="text-foreground-600 text-sm">{t('article_subtitle')}</p>
          </div>
          <Link
            to="/category/football"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer group"
          >
            {t('view_all')}
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform duration-200 w-3 h-3 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6 mb-8">
          {featured.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.publishedAt}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.slice(3, 9).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex gap-3 p-3 rounded-lg transition-all duration-200 hover:bg-background-50 cursor-pointer group"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0">
                <div>
                  <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <h4 className="font-heading font-medium text-sm text-foreground-800 line-clamp-2 mt-1 group-hover:text-primary-600 transition-colors duration-200">
                    {article.title}
                  </h4>
                </div>
                <span className="text-xs text-foreground-500">{article.publishedAt}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}